import changeIsToastShown from '../actions/changeIsToastShown';
import { getToastViewState } from '../store/Store';
import { mutator } from 'satcheljs';

/**
 * Mutator for the action which changes the current isToastShown in the state as per the action message
 */
export default mutator(
    changeIsToastShown,
    function changeIsToastShownMutator(actionMessage: { isToastShown: boolean }) {
        const { isToastShown } = actionMessage;
        isToastShown !== getToastViewState().isToastShown &&
            (getToastViewState().isToastShown = isToastShown);
    }
);
